<template>
  <div class="portal-content">
    <div class="portal-content-top">
      <div class="portal-content-top-left">
        <PersonalData class="wrapper_radius" />
      </div>
      <div class="portal-content-top-right">
        <ServiceApplication
          :showApplicationNum="showApplicationNum"
          class="wrapper_radius"
        />
      </div>

    </div>
    <div class="portal-content-bottom">
      <div class="portal-content-bottom-left">
        <div
          class="portal-content-bottom-left-asset wrapper_radius"
          :style="{height:hotDataHeight}"
        >
          <HotData @getedHotData="getedHotData" />
        </div>
        <div
          class="portal-content-bottom-left-schedule wrapper_radius"
          :style="{height:`calc(100% - ${hotDataHeight} - 24px )`}"
        >
          <Schedule />
        </div>
      </div>
      <div class="portal-content-bottom-right">
        <div class="portal-content-bottom-right-news">
          <NewsIndex class="wrapper_radius" />

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PersonalData from "./Modules/PersonalData";
import ServiceApplication from "./Modules/ServiceApplication";
import HotData from "./Modules/HotData";
import NewsIndex from "./Modules/NewsIndex";
import Schedule from "./Modules/Schedule";
export default {
  name: "Index",
  data() {
    return {
      screenSizeMore1720: true,
      showApplicationNum: 24,
      hotDataHeight: "568px",
    };
  },
  components: {
    PersonalData,
    ServiceApplication,
    HotData,
    NewsIndex,
    Schedule,
  },
  created() {
    let windowWidth = document.documentElement.clientWidth;
    this.screenSizeMore1720 = windowWidth >= 1720;
    this.showApplicationNum = this.screenSizeMore1720 ? 24 : 16;
    window.addEventListener("resize", () => {
      let windowWidth = document.documentElement.clientWidth;
      this.screenSizeMore1720 = windowWidth >= 1720;
      this.showApplicationNum = this.screenSizeMore1720 ? 24 : 16;
    });
  },
  mounted() {
    let federatedCode = this.getQueryString("federatedCode");
    let state = this.getQueryString("state");
    if (federatedCode && state) {
      let url =
        window.location.protocol +
        "//" +
        window.location.host +
        "/main.html" +
        "#" +
        JSON.parse(decodeURIComponent(state)).path +
        "?" +
        `${"federatedCode=" + federatedCode + "&state=" + state}`;
      console.log("url", url);
      window.location.href = url;
    }
  },
  methods: {
    getedHotData(hotDataNumber) {
      console.log("yy", hotDataNumber);
      this.hotDataHeight = hotDataNumber * 51 + 253 + 6 - 2 + "px";
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";
.portal-content {
  margin: 50px auto 0;
  width: 1680px;
  box-sizing: border-box;
  line-height: 25px;
  font-size: 14px;
  color: #333333;
  @include portalMedia;
  &-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 24px;
    &-left {
      width: 25%;
      min-width: $home-left-min-width;
      height: 336px;
      padding-right: 12px;
    }
    &-right {
      width: 75%;
      max-width: calc(100% - 300px);
      padding-left: 12px;
      height: 336px;
    }
  }
  &-bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    min-height: 1095px;
    margin-bottom: 20px;
    &-left {
      width: 25%;
      min-width: $home-left-min-width;
      height: 1096px;
      padding-right: 12px;
      &-asset {
        width: 100%;
        margin-bottom: 24px;
        border-bottom: 2px solid rgb(153, 90, 115);
      }
      &-schedule {
        width: 100%;
      }
    }
    &-right {
      height: 1096px;
      padding-left: 12px;
      width: 75%;
      max-width: calc(100% - 300px);
      &-news {
        height: 100%;
      }
    }
  }
}
</style>